import {Dispatch} from 'redux';
import {
  post,
  makeUrl,
} from '../../utils/fetcher';

import {
  METHODS,
} from '../../constants';
import {DataExportConnectionTestResult} from './types';

export const sendTestConnectionToHEC = (
  collectorUrl: string,
  token: string,
  streamTypeId: string,
  siemSpecificData: {[key: string]: string | number},
  // eslint-disable-next-line no-unused-vars
  callback: (result: DataExportConnectionTestResult) => void,
) => {
  const url = makeUrl(METHODS.TEST_HEC_CONNECTION);
  const data = {
    collectorUrl,
    token,
    streamTypeId,
    siemSpecificData,
  };
  return (dispatch: Dispatch) => post(url, data, dispatch)
    .then((response) => {
      if (response && response.data) {
        callback(response.data);
      }
    });
};
